import {IEnvironment} from './environment.interface';

export const environment: IEnvironment = {
    production: true,
    useJsConfig: true,
    // Values below are unused due to useJsConfig flag
    baseUri: undefined,
    instance: undefined,
    ssoHelperUrl: undefined,
    demoenv: false,
    assetBaseUri: "https://assets.webmate.io",
    devtoolsChromiumFrontendUrl: "https://devtools-chrome.webmate.io",
    devtoolsWebkitFrontendUrl: "https://devtools-webkit.webmate.io",
    overrideImageSocketBaseURI: undefined,
    seleniumUrl: undefined,
    appiumInspectorFrontendUrl: "https://appium-inspector.webmate.io",
    analyticsPosthogEnabled: true,
    analyticsPosthogKey: undefined,
    analyticsPosthogUrl: undefined,
};
